window.addEventListener('load', function() {
    jQuery(document).on("blur", 'input[name="address[postcode]"]', function () {
        var targetPostcode = jQuery(this).val();
        getPostcodeData(targetPostcode);
    });

    function getPostcodeData(targetPostcode) {
        var cep = targetPostcode.replace(/\D/g, "");
        if (cep != "") {
            var checkCep = /^[0-9]{8}$/;
            if (checkCep.test(cep)) {
                fieldsWait();
                $.getJSON(
                    "https://viacep.com.br/ws/" + cep + "/json/?callback=?",
                    function (response) {
                        if (!("erro" in response)) {
                            console.log(response);
                            fieldsPopulate(response);
                        } else {
                            fieldsClean();
                            alert("CEP não encontrado.");   
                        }
                    }
                );
            } else {
                fieldsClean();
                alert("Formato de CEP inválido.");
            }
        } else {
            fieldsClean();
        }
    }

    function getRegionByInitials(initials) {
        var regionsData = {
            AC: "Acre",
            AL: "Alagoas",
            AP: "Amapá",
            AM: "Amazonas",
            BA: "Bahia ",
            CE: "Ceará",
            DF: "Distrito Federal ",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins",
        };
        return regionsData[initials];
    }

    function fieldsPopulate(fieldsData) {
        jQuery('input[name="address[street_name]"]').val(fieldsData.logradouro).change();
        jQuery('input[name="address[neiborhood]"]').val(fieldsData.bairro).change();
        jQuery('input[name="address[city]"]').val(fieldsData.localidade).change();
        jQuery('select[name="address[state]"]').val(fieldsData.uf).change();     
     
    }

    function fieldsClean() {
        jQuery('input[name="address[postcode]"]').val("").change();
        jQuery('input[name="address[street_name]"]').val("").change();
        jQuery('input[name="address[neiborhood]"]').val("").change();
        jQuery('input[name="address[city]"').val("").change();
        jQuery('select[name="address[state]"]').val("").change();            
    }

    function fieldsWait() {
        jQuery('input[name="address[street_name]"]').val("...").change();
        jQuery('input[name="address[neiborhood]"]').val("...").change();
        jQuery('input[name="address[city]"').val("...").change();
        jQuery('select[name="address[state]"]').val("").change();       
    }
});